import api from "@/apis/dictionary/PickListAPI";
import Crud from "@/stores/crud-base";
var crud = new Crud("PickList", api);
import { MSEnum } from "@/commons/enumeration";
import commonFn from "@/commons/commonFunction";

import { ModulePickList } from "@/stores/module-const";
import { Array } from "core-js";

let state = {
  ...crud.state,
  _config: {
    field: {
      key: "ID",
      name: "Name",
    },
  },
};
/**
 * Mapping state theo picklist type value
 */
for (let i in MSEnum.PickListType) {
  state[MSEnum.PickListType[i]] = [];
}

let getters = {
  ...crud.getters,
};
/**
 * Mapping state theo picklist type name
 */
for (let i in MSEnum.PickListType) {
  getters[i] = function (state) {
    return state[MSEnum.PickListType[i]];
  };
}

const actions = {
  ...crud.actions,
  /**
   * Xử lý load dữ liệu cho picklist
   * Kiểm tra nếu chưa có dữ liệu nào thì load món đó
   */
  async loadPickList(context, payload) {
    const me = this;
    const fn = async function (type) {
      let res = await api.getComboboxData(type);
      context.commit("setComoboboxItems", { data: res, type: type });
    };

    if (Array.isArray(payload)) {
      for (var i = 0; i < payload.length; i++) {
        await fn(payload[i]);
      }
    } else {
      fn(payload);
    }
  },
};

const mutations = {
  ...crud.mutations,
  setComoboboxItems(state, res) {
    state[res.type] = res.data;
  },
  /*
   * @override
   * custom update lại theo type
   * pvduy 26/03/2021
   */
  insertItem(state, data) {
    let items = state[data.Type];
    items.insertAt(0, data);
    state.items.insertAt(0, data);
  },
  /*
   * custom update lại theo type
   * pvduy 26/03/2021
   */
  updateItem(state, data) {
    let keyField = state._config.field.key;
    if (keyField) {
      let id = data[keyField];
      for (let i = 0; i < state[data.Type].length; i++) {
        let item = state[data.Type][i];
        if (item[keyField] === id) {
          Object.assign(item, data);
          Object.assign(state.items[i], data);
        }
      }
    }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
